import { IWarning, WarningReferences } from './smart-suggestion.model'

export class ResetSmartSuggestionState {
  public static readonly type = '[SmartSuggestionMeta] Reset to Initial State'
  constructor() {}
}

export class GenerateKitCompositionsAction {
  public static readonly type =
    '[SmartSuggestionMeta] Generate Kit Compositions'
  constructor() {}
}

export class AddWarningAction {
  public static readonly type = '[SmartSuggestionMeta] Add Warning'
  constructor(public payload: IWarning) {}
}

export class RemoveWarningAction {
  public static readonly type = '[SmartSuggestionMeta] Remove Warning'
  constructor(public payload: WarningReferences) {}
}

export class OpenWarningModalAction {
  public static readonly type = '[SmartSuggestionMeta] Open Warning Modal'
  constructor() {}
}

export class CloseWarningModalAction {
  public static readonly type = '[SmartSuggestionMeta] Close Warning Modal'
  constructor() {}
}
